export default {
    activity_log: 'កំណត់ហេតុការចូលប្រេីប្រាស់',
    action_name: 'ឈ្មោះប្រើការ',
    reference_for: 'ឯកសារយោងសម្រាប់',
    ip: 'IP',
    actions: {
        change_email: {
            title: 'ប្តូរអ៊ីមែល',
            content: 'អ្នកបានផ្លាស់ប្តូរអ៊ីមែលរបស់អ្នកដោយជោគជ័យ។',
        },
        change_root_password_cloud_server: {
            title: 'ផ្លាស់ប្តូរពាក្យសម្ងាត់ Root របស់ Cloud Server',
            content:
                'អ្នកទើបតែបានផ្លាស់ប្តូរពាក្យសម្ងាត់ root របស់ Cloud Server ។',
        },
        use_trial_sms: {
            title: 'ប្រើសារ SMS សាកល្បង',
            content: 'អ្នកបានប្រើសារ SMS សាកល្បង',
        },
        login: {
            title: 'ចូល',
            content: 'អ្នកទើបតែចូលដោយជោគជ័យ',
            error: {
                wrong_password:
                    'ការចូលបានបរាជ័យដោយសារតែពាក្យសម្ងាត់មិនត្រឹមត្រូវ',
            },
        },
        register: {
            title: 'ចុះឈ្មោះ',
            content: 'អ្នកទើបតែបានចុះឈ្មោះដោយជោគជ័យ',
        },
        verify_two_factor: {
            title: 'ការផ្ទៀងផ្ទាត់កម្មវិធី Two-Factor',
            content:
                'អ្នកទើបតែបានផ្ទៀងផ្ទាត់កម្មវិធី Two-Factor របស់អ្នកដោយជោគជ័យ',
            error: {
                invalid_2fa_code:
                    'ការផ្ទៀងផ្ទាត់កម្មវីធី Two-factor បានបរាជ័យដោយសារតែលេខកូដមិនត្រឹមត្រូវ',
            },
        },
        change_shared_hosting_password: {
            title: 'ប្តូរពាក្យសម្ងាត់របស់ Shared Hosting',
            content: 'អ្នកទើបតែបានផ្លាស់ប្តូរពាក្យសម្ងាត់របស់ Shared Hosting។',
        },
        change_wordpress_hosting_password: {
            title: 'ប្តូរពាក្យសម្ងាត់របស់ WordPress Hosting',
            content:
                'អ្នកទើបតែបានផ្លាស់ប្តូរពាក្យសម្ងាត់របស់ WordPress Hosting។',
        },
        change_cloud_hosting_terminal_password: {
            title: 'ការផ្លាស់់ប្តូរពាក្យសម្ងាត់របស់ Cloud Hosting Terminal',
            content:
                'អ្នកទើបតែបានផ្លាស់ប្តូរពាក្យសម្ងាត់ terminal របស់ Cloud Hosting ។',
        },
        change_cloud_hosting_panel_password: {
            title: 'ការផ្លាស់់ប្តូរពាក្យសម្ងាត់របស់ Cloud Hosting Panel',
            content:
                'អ្នកទើបតែបានផ្លាស់ប្តូរពាក្យសម្ងាត់ Panel របស់ Cloud Hosting ។',
        },
        google_login: {
            title: 'ចូលទៅកាន់ Google',
            content: 'អ្នកបានចូលតាមរយៈគណនី Google ដោយជោគជ័យ',
        },
        google_linked: {
            title: 'តំណរភ្ជាប់ Google',
            content: 'អ្នកបានភ្ជាប់គណនី Google របស់អ្នកដោយជោគជ័យ',
        },
        google_unlink: {
            title: 'ផ្ដាច់​ Google',
            content: 'អ្នកបានផ្ដាច់គណនី Google របស់អ្នកបានដោយជោគជ័យ',
        },
    },
    detail: {
        title: 'ព័ត៌មានលម្អិតអំពីសកម្មភាព',
        field_name: 'ឈ្មោះ Field',
        previous_value: 'Value ពីមុន',
        new_value: 'Value ថ្មី',
    },
    search_placeholder: 'បញ្ចូល IP',
    select_action_placeholder: 'ស្វែងរក & ជ្រើសរើសសកម្មភាព',
    recommend: 'ការណែនាំ',
};
